import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "Calculer 25% d'un montant - Calculatrice 25 pour cent - Apprenez combien font 25%";
const DESCRIPTION =
  "Calculer 25% d pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "r 25% d, calculatrice r 25% d, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/25percent/";
function Calculator() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  Comment calculer 25% d'une valeur spécifique :
                </h2>
                <ul>
                  <li>
                    Multipliez la valeur par 25% sous forme de fraction. Le pourcentage 25% peut être représenté comme une fraction de la manière suivante : 25/100 ou 1/4.
                  </li>
                  <li>
                    Ensuite, multipliez la valeur originale par la fraction. Supposons que vous ayez une certaine valeur dont vous souhaitez calculer 25%, disons que cette valeur est égale à 100, vous pouvez utiliser l'équation suivante :
                    <br />
                    Le pourcentage = (Valeur originale × Fraction 25/100)
                  </li>
                  <li>
                    Ou vous pouvez simplement effectuer le calcul comme suit : divisez la valeur originale par 4.
                    <br />
                    Le pourcentage = Valeur originale / 4
                  </li>
                  <li>Vous obtiendrez le pourcentage requis, qui est 25% de la valeur originale.</li>
                </ul>
                <b>
                  Vous pouvez également utiliser la calculatrice électronique suivante pour calculer 25% d'un nombre ou d'un montant spécifique :
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={25} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />

    </div>
  );
}
export default Calculator;
